import { traduccionesDictionary } from '../Traducciones';
export default class Traductor {
    constructor() {
        this.language = 'ES';
    }

    getTraduction = property => {
        if (traduccionesDictionary[property]) {
            return traduccionesDictionary[property][this.language];
        } else {
            return property;
        }
    };

    getLanguage = () => this.language;

    updateLanguage = newLanguage => {
        this.language = newLanguage;
    };
}
